import { getEntityURL } from '../routing';
import htmlDecode from './htmlDecode';
import * as field from './transforms.fields';

export const transformItems = (items) =>
  items.map((item) => {
    // Build URL object to match the common backend-returned object
    // to make us able to use standard getEntityURL() function.
    const entity = {};
    entity.url = {
      url: item.url,
      is_external: false,
      entity_type: 'node',
      entity_bundle: item.type,
    };

    return {
      type: item.type_label ? item.type_label : '',
      title: item.title ? htmlDecode(String(item.title)) : '',
      description: item.description ? item.description : '',
      image: field.getPicture(
        {
          field_media_image: [
            {
              image_styles: { original: htmlDecode(String(item.image_original)) },
              alt: item.image_alt || '',
            },
          ],
        },
        'field_media_image',
        {
          'min-xs': {
            '1x': 'dynamic_listing',
          },
        },
        'dynamic_listing'
      ),
      nextLink: getEntityURL(entity),
      timestamp: item.created ? Number.parseInt(item.created, 10) : 0,
      isDesktopDescriptionHidden: false,
      isMobileDescriptionHidden: false,
    };
  });
